/*
 * @Author: 番茄炒蛋蛋 wzh15802755802@163.com
 * @Date: 2025-03-06 17:54:17
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-04-17 13:47:55
 * @FilePath: \qbot-api-demo\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line
import Vue from 'vue';
import moment from 'moment';
import App from './App';
import router from './router';
import axios from 'axios';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// import { ACCESS_TYPE } from '@/constants';


const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

console.log('【main.js】开始初始化');

if(window.location.origin.indexOf("localhost")>-1 || window.location.origin.indexOf("jyptwebtest")>-1){
    // Vue.prototype.$globalUrl = 'https://jypt.idianjiao.com';
    Vue.prototype.$globalUrl = 'https://jyptwebtest.idianjiao.com';
}else{
    Vue.prototype.$globalUrl = 'https://jypt.idianjiao.com';
    // Vue.prototype.$globalUrl = 'https://jyptwebtest.idianjiao.com';
}
console.log('【main.js】全局URL:', Vue.prototype.$globalUrl);

try {
    let iconpath = 'https://cdn3.codesign.qq.com/icons/XzKaDZdEa7j2GPL/latest/iconfont.js';
    vhtml.Icon.setDefaultRemoteSrc && vhtml.Icon.setDefaultRemoteSrc(iconpath);
} catch (e) {
    console.log('load remote icon error');
}

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

// import "element-ui/lib/theme-chalk/index.css";//引入element-ui样式

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '精准教研教学平台-专注教师教研与教学服务，助力教师专业提升！';
    if (to.name && window.$initType !== to.name) {
        window.location.reload();
    }
    next();
});

// 封装获取 token 的函数
async function getToken(aitype_id) {
    console.log('【main.js】请求token，AI类型ID:', aitype_id);
    try {
        const res = await axios.post(Vue.prototype.$globalUrl + '/api.php/Index/ai_token?from=ajax&ver=20231024', 
            'aitype_id=' + aitype_id);
        
        if (res.data.retInt == 1) {
            console.log('【main.js】获取token成功，长度:', res.data.retRes.token.length);
            return res.data.retRes.token;
        } else {
            console.error('【main.js】获取token失败，响应:', res.data);
            return '';
        }
    } catch (error) {
        console.error('【main.js】获取token请求失败:', error);
        return '';
    }
}

// 清理旧的WebSocket连接
function cleanupOldWebSocketConnections() {
    // 清理可能存在的旧连接
    if (window.socketInstance && window.socketInstance.connected) {
        console.log('【main.js】清理旧WebSocket连接');
        window.socketInstance.disconnect();
    }
}

let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

webIMType = [5];
window.$initTypeKey = 5;
webIMSource = 'client';

Vue.prototype.webIMSource = webIMSource;

Object.defineProperty(window, 'userType', {
    writable: false,
    enumerable: false,
    configurable: false,
    value: 2
});

window.$initType = 'ChatDemo';

const hash = window.location.hash;
const hashIndex = hash.indexOf('?');
let aitype_id = 5;

// 检查URL参数中的AI类型
if (hashIndex !== -1) {
    const queryString = hash.slice(hashIndex);
    const urlParams = new URLSearchParams(queryString);
    const urlAitypeId = urlParams.get('aitype_id');
    if (urlAitypeId) {
        aitype_id = parseInt(urlAitypeId);
        console.log('【main.js】从URL参数获取AI类型ID:', aitype_id);
    }
}

// 检查sessionStorage中是否有待切换的AI类型
const pendingAiType = sessionStorage.getItem('pendingAiType');
if (pendingAiType) {
    aitype_id = parseInt(pendingAiType);
    console.log('【main.js】从sessionStorage恢复AI类型ID:', aitype_id);
    sessionStorage.removeItem('pendingAiType');
}

Vue.prototype.$urlQuery = {
    aitype_id,
};

console.log('【main.js】最终AI类型ID:', aitype_id);

let tokenGet = webIMType.map(type => {
    return new Promise(async (resolve, reject) => {
        try {
            let demoToken = await getToken(aitype_id);
            console.log('【main.js】获取到token，类型:', type, '长度:', demoToken.length);
            
            let result = {
                type: type,
                token: demoToken,
                access: 'ws'
            };
            console.log('【main.js】token获取结果:', result);
            resolve(result);
        } catch (error) {
            console.error('【main.js】获取token失败:', error);
            reject(error);
        }
    });
});

console.log('【main.js】开始获取token');

Promise.all(tokenGet).then(res => {
    console.log('【main.js】所有token获取完成:', res);
    
    Object.defineProperty(window, 'webimToken', {
        writable: false,
        enumerable: false,
        configurable: true,
        value: res
    });
    
    // 清理可能存在的旧连接
    cleanupOldWebSocketConnections();
    
    (async () => {
        try {
            let mixin = await import('@/manage/index');
            Vue.mixin(mixin);
            
            /* eslint-disable no-new */
            new Vue({
                el: '#app',
                router,
                render (h) {
                    return h(App);
                }
            }).$mount('#app');
            
            console.log('【main.js】Vue应用启动完成');
        } catch (error) {
            console.error('【main.js】应用启动失败:', error);
        }
    })();
}).catch(e => {
    console.error('【main.js】token获取失败，应用无法启动:', e);
    alert('初始化失败，请刷新页面重试');
});

// 导出getToken函数供其他模块使用
export { getToken, cleanupOldWebSocketConnections };


// WEBPACK FOOTER //
// ./src/main.js